<template> 
  <div class="blog p-0">
    <Header />
    <b-container class="content">
      <b-row>
        <b-col cols="12" lg="9" order="12" order-lg="1" >
          <Post 
            v-if="current && current.show" 
            :current="current" 
            @setTag="setTag" 
            class="mb-5" 
            @sendMessage="sendMessage" 
          />
          <Posts 
            v-if="view && current && current.content" 
            :current="current.content.id" 
            :view="view" 
            :filters="filters" 
            @resetKw="resetKw" 
            @resetTag="resetTag" 
            @postSelected="postSelected" 
            class="mb-5" 
          />
        </b-col>

        <b-col cols="12" lg="3" order="1" order-lg="12" class="mb-5" >
          <div class="dark-color text-white py-5 px-4 sticky-top shadow">
            <Search :posts="posts" :topics="topics" :filters="filters" @setTag="setTag" @search="setSearchCriterias" @resetKw="resetKw" />
            <SubscriptionForm v-if="subscriptionForm" @subscribed="subscribed" class="mt-5" />
          </div>
        </b-col>
      </b-row>

      <Ebook />

    </b-container>
    
    <Footer />  
  </div>
</template>

<script>
import Post from '@/components/Post.vue'
import Posts from '@/components/Posts.vue'
import Search from '@/components/Search.vue'
import SubscriptionForm from '@/components/SubscriptionForm.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Ebook from '@/components/Ebook.vue'
import Partnerz from '@/components/Partnerz.vue'
import axios from 'axios'

export default {
  name: 'blog',
  components: {
    Post,
    Posts,
    Search,
    SubscriptionForm,
    Header,
    Footer,
    Ebook,
    Partnerz,
  },
  data() {
    return {
      posts: {},
      current: {},
      view: [],
      filters: {
        tag: null,
        keywords: null
      },
      subscriptionForm: true,
      errors: []
    }
  },
  computed: {
    topics() {
      let topics = []
      if (this.posts) {
        for(let i in this.posts) {    
          let post = this.posts[i]      
          for(let j in post.tags) {
            let tag = post.tags[j]
            if(!topics.includes(tag)) {
              topics.push(tag)
            }
          }
        }
      }
      
      return topics
    }
  },
  mounted() {
    this.getPosts()

    let blog = document.getElementsByClassName('blog')[0]
    let navbar = document.getElementById('navbar')

    if(blog) blog.style.margin = navbar.offsetHeight + 'px 0 0 0'
  },
  methods: {
    postSelected() {
      this.resetKw()
      this.resetTag()
      this.setCurrent()
    },
    setCurrent() {
      let post = this.$route.params.title 

      if (post && post !== 'recent') {
        this.current = {
          show: true,
          content: this.findMatchingArticle(post)
        }
      } else if (this.filters.keywords === null && this.filters.keywords === null && post && post === 'recent') {
        this.current = {
          show: true,
          content: this.posts[0]
        }
      } else if (this.filters.keywords !== null || this.filters.keywords !== null) {
        this.current = {
          show: false,
          content: null
        }
      }
    },
    subscribed() {
      this.subscriptionForm = false
    },
    setSearchCriterias(search) {
      if(search.keywords && search.keywords !== null) {
        this.filters.keywords = search.keywords
      }

      this.runSearch()      
      return false
    },
    setTag(tag) {
      if(tag && tag !== null) {
        this.filters.tag = tag
      }

      this.runSearch()
      return false
    },
    runSearch() {
      this.current.show = false
      this.view = []

      for(let i in this.posts) {
        let post = this.posts[i]
        post.hits = 0
        
        if (this.filters.keywords !== null) {
          post.hits = this.scanVisibleText(post.hits, post, this.filters.keywords)
        }

        if (this.filters.tag !== null) {
          if (post.tags.includes(this.filters.tag)) {
            if (this.filters.keywords === null || (this.filters.keywords !== null && post.hits > 0)) {
              this.view.push(post)
            }
          }
        } else {
          if (post.hits > 0) {
            this.view.push(post)
          }
        }
      }

      this.view.sort(function (a, b) {
        return b.hits - a.hits
      })
    },
    scanVisibleText(hits, post, value) {
          hits += this.countOcurrences(post.title, value)

          for(let j in post.tags) {
            hits += this.countOcurrences(post.tags[j], value)
          }

          for(let k in post.content) {
            hits += this.countOcurrences(post.content[k].text, value)
          }

          return hits
    },
    countOcurrences(str, value) {
      value = this.normalizeString(value).toLowerCase().replace(/[^A-z0-9\s]/g,'')
      var regExp = new RegExp(value, "gi")
      str = this.normalizeString(str).toLowerCase().replace(/[^A-z0-9\s]/g,'')
      let res = (str.match(regExp) || []).length

      return res
    },
    resetKw() {
      this.filters.keywords = null
      this.$emit('resetKw')
      if(this.filters.tag === null) {
        this.view = this.posts
        this.setCurrent()
      }
      else this.runSearch()

      return false
    },
    resetTag() {
      this.filters.tag = null
      this.$emit('resetTagg')
      if(this.filters.keywords === null) {
        this.view = this.posts
        this.setCurrent()
      }
      else this.runSearch()

      return false
    },
    resetSearch() {
      this.filters = {
        tag: null,
        keywords: null
      }
    },
    getImgLinks() {
      for (let p in this.view) { 
        let post = this.view[p]
        
        if (post.img) {
          post.img = require(`@/assets/images/blog/` + post.img)
        }
      }
      return false
    },
    getPosts() {
      axios.get('/api/posts')
      .then(response => {
        this.posts = response.data
        this.view = this.posts
        this.setCurrent()
        this.getImgLinks()
      })
      .catch(e => {this.errors.push(e)})
    },
    sendMessage(subject) {
      this.$emit('sendMessage', subject)
    },
    findMatchingArticle(title) {
      for (let a in this.posts) {
        if (this.posts[a].url === title) return this.posts[a]
      }
    },
    normalizeString(string) {
        return string.split('').map(function (letter) {
            let i = this.accents.indexOf(letter)
            return (i !== -1) ? this.out[i] : letter
            }.bind({
              accents: 'ÀÁÂÃÄÅĄàáâãäåąßÒÓÔÕÕÖØÓòóôõöøóÈÉÊËĘèéêëęðÇĆçćÐÌÍÎÏìíîïÙÚÛÜùúûüÑŃñńŠŚšśŸÿýŽŻŹžżź',
              out: 'AAAAAAAaaaaaaaBOOOOOOOOoooooooEEEEEeeeeeeCCccDIIIIiiiiUUUUuuuuNNnnSSssYyyZZZzzz'
            })
        ).join('')
    },
  }
}
</script>

<style scoped>
.background,
.overlay {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
}

.content {
  position: relative;
  z-index: 10;
}

.footer {
  position: relative;
  z-index: 11;
}

.sticky-top {
  top: 15vh;
}
</style>

